import { type Common } from '../common.js';
import {
  type CreateValues,
  type FindAllOptions,
  type FlowAlertRule,
  type UpdateValues,
} from '../models/flow/flowAlertRule.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/flow-alert-rules';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FindAllOptions): Promise<FlowAlertRule[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<FlowAlertRule> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<FlowAlertRule> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<FlowAlertRule> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<FlowAlertRule> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
